import React from 'react';
import type { FC } from 'react';

interface SVGWhiteIconProps {
    className?: string;
}

export const SVGWhiteIcon: FC<SVGWhiteIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>SVG White Icon</title>
            <path
                d="M19.3359 1V6.33333C19.3359 6.68695 19.4764 7.02609 19.7265 7.27614C19.9765 7.52619 20.3156 7.66667 20.6693 7.66667H26.0026"
                stroke="white"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.3359 25H10.0026C9.29536 25 8.61708 24.719 8.11699 24.219C7.61689 23.7189 7.33594 23.0406 7.33594 22.3333V3.66667C7.33594 2.95942 7.61689 2.28115 8.11699 1.78105C8.61708 1.28095 9.29536 1 10.0026 1H19.3359L26.0026 7.66667V22.3333C26.0026 23.0406 25.7217 23.7189 25.2216 24.219C24.7215 24.719 24.0432 25 23.3359 25Z"
                stroke="white"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect y="12.3333" width="14.6667" height="8" rx="0.666667" fill="white" />
            <path
                d="M2 17.8333C2 18.1093 2.224 18.3333 2.5 18.3333H3.33333C3.51014 18.3333 3.67971 18.263 3.80474 18.138C3.92976 18.013 4 17.8434 4 17.6666V16.9999C4 16.8231 3.92976 16.6535 3.80474 16.5285C3.67971 16.4035 3.51014 16.3333 3.33333 16.3333H2.66667C2.48986 16.3333 2.32029 16.263 2.19526 16.138C2.07024 16.013 2 15.8434 2 15.6666V14.9999C2 14.8231 2.07024 14.6535 2.19526 14.5285C2.32029 14.4035 2.48986 14.3333 2.66667 14.3333H3.5C3.63261 14.3333 3.75979 14.3859 3.85355 14.4797C3.94732 14.5735 4 14.7006 4 14.8333"
                stroke="#11161C"
                strokeWidth="0.857143"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M6 14.3333L7.33333 18.3333L8.66667 14.3333"
                stroke="#11161C"
                strokeWidth="0.857143"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M12.668 14.3333H12.0013C11.6477 14.3333 11.3085 14.4737 11.0585 14.7238C10.8084 14.9738 10.668 15.313 10.668 15.6666V16.9999C10.668 17.3535 10.8084 17.6927 11.0585 17.9427C11.3085 18.1928 11.6477 18.3333 12.0013 18.3333H12.668V16.9999"
                stroke="#11161C"
                strokeWidth="0.857143"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
        </svg>
    );
};
